import { Injectable } from "@angular/core";
import { LoadingController } from "@ionic/angular";

@Injectable({
  providedIn: "root",
})
export class LoaderService {
  private loading: HTMLIonLoadingElement | null = null;

  constructor(private loadingController: LoadingController) {}

  async presentLoader(title: string, dur?: number, spin?: any) {
    // Prevent multiple loaders stacking up
    if (this.loading) {
      await this.hideLoader();
    }
    this.loading = await this.loadingController.create({
      message: title,
      translucent: true,
      spinner: spin || "circles" || "crescent",
      keyboardClose: true,
    });
    await this.loading.present();
  }
  async hideLoader() {
    if (this.loading) {
      await this.loading.dismiss();
      this.loading = null;
    }
    // const res = await this.loadingController.dismiss().then(() => { }, () => { });
    // return await res;
    //  const { role, data } = await loading.onDidDismiss();
    // console.log('Loading dismissed with role:', role);
  }
}
